import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_LOGIN_INFO](state, { userInfo, authToken, secondFactorKey, enable2FactorAuth, fiscalYear, yearList }) {
    console.log(types.SET_LOGIN_INFO, userInfo, authToken, secondFactorKey, enable2FactorAuth, fiscalYear, yearList)
    Vue.set(state, 'userInfo', userInfo)
    Vue.set(state, 'authToken', authToken)
    Vue.set(state, 'secondFactorKey', secondFactorKey)
    Vue.set(state, 'enable2FactorAuth', enable2FactorAuth)
    Vue.set(state, 'fiscalYear', fiscalYear)
    Vue.set(state, 'yearList', yearList)
  }
}
